import { createContext, useContext } from 'react';

export interface IPortalContextValue {
  gates: Record<string, JSX.Element>;
  teleport: (gateName: string, element: JSX.Element) => void;
  removeGate: (gateName: string) => void;
  removeAllGate: () => void;
}

export const PortalContext = createContext<IPortalContextValue>({
  gates: {},
  teleport: () => {},
  removeGate: () => {},
  removeAllGate: () => {}
});

export function usePortalContext(): IPortalContextValue {
  return useContext(PortalContext);
}
